import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/common/Primitives";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { CommOverview, CommSettings, CommAutomations, CommTemplates } from "@/components/comm/CommPanels";
import { CommConsents, CommMessages, CommFeedback } from "@/components/comm/CommPanels2";

const TABS = [
  { v: "overview", label: "Übersicht" },
  { v: "automations", label: "Automatisierungen" },
  { v: "templates", label: "Vorlagen" },
  { v: "consents", label: "Einwilligungen" },
  { v: "messages", label: "Nachrichten & Historie" },
  { v: "feedback", label: "Feedback" },
  { v: "settings", label: "Einstellungen" },
];

export default function Communication() {
  const [tab, setTab] = useState("overview");
  const { data: s } = useQuery({ queryKey: ["wa-status"], queryFn: async () => (await api.get("/wa/status")).data });
  const { data: tpl, refetch } = useQuery({ queryKey: ["wa-templates"], queryFn: async () => (await api.get("/wa/templates")).data });
  const templates = tpl?.items || [];

  return (
    <div>
      <PageHeader title="Kundenkommunikation" description="Automatisierte WhatsApp-Kommunikation · offizielle Business Platform" />
      <Tabs value={tab} onValueChange={setTab} className="mb-4">
        <TabsList className="flex-wrap h-auto">
          {TABS.map((t) => <TabsTrigger key={t.v} value={t.v} data-testid={`comm-tab-${t.v}`}>{t.label}</TabsTrigger>)}
        </TabsList>
      </Tabs>
      {tab === "overview" && <CommOverview />}
      {tab === "automations" && <CommAutomations templates={templates} />}
      {tab === "templates" && <CommTemplates templates={templates} refetch={refetch} />}
      {tab === "consents" && <CommConsents />}
      {tab === "messages" && <CommMessages templates={templates} status={s?.status} />}
      {tab === "feedback" && <CommFeedback />}
      {tab === "settings" && <CommSettings />}
    </div>
  );
}
